//
// TIME CONVERSION

// Converts number in ms to '00:00:00' or custom string format
export const msecToTime = (ms, customFormat) => {
  const msInt = checkInt(ms)

  const totalSeconds = Math.floor(msInt / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const totalMinutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds - minutes * 60 - hours * 3600

  if (customFormat) {
    const units = customFormat.split(':')
    return units
      .map((unit) => {
        const unitLC = unit.toLowerCase()
        if (unitLC === 'hh') return hours < 10 ? '0' + hours : hours
        if (unitLC === 'h') return hours

        if (units.includes('h')) {
          if (unitLC === 'mm') return minutes < 10 ? '0' + minutes : minutes
          if (unitLC === 'm') return minutes
        } else {
          if (unitLC === 'mm')
            return totalMinutes < 10 ? '0' + totalMinutes : totalMinutes
          if (unitLC === 'm') return totalMinutes
        }

        if (unitLC === 'ss') return seconds < 10 ? '0' + seconds : seconds
        if (unitLC === 's') return seconds
      })
      .join(':')
  }

  return (
    (hours < 10 ? '0' + hours : hours) +
    ':' +
    (minutes < 10 ? '0' + minutes : minutes) +
    ':' +
    (seconds < 10 ? '0' + seconds : seconds)
  )
}

export const secToTime = (s, customFormat) => {
  return msecToTime(checkInt(s) * 1000, customFormat)
}

export const minToTime = (m, customFormat) => {
  return secToTime(checkInt(m) * 60, customFormat)
}

export const secToMsec = (sec) => Math.round(sec * 1000)

export const msecToSec = (ms) => Math.round(ms / 1000)

export const secToMin = (s) => Math.round(s / 60)

const checkInt = (int) => {
  const checkedInt = typeof int === 'string' ? parseInt(int) : int
  if (Number.isNaN(checkedInt))
    throw Error('Parameter passed to conversion function must be an integer')
  return checkedInt
}

//
// STRING CONVERSION/MANIPULATION/PARSING

// Helper function to extract specific string content
export const extractStringFragment = (content, regex) => {
  if (!content || !(regex instanceof RegExp)) return ''
  const result = regex.exec(content)
  return result ? result[1] : ''
}

export const getNativeLocalPath = (cdvPath) => {
  return new Promise((resolve, reject) => {
    window.resolveLocalFileSystemURL(
      `cdvfile://localhost/persistent/${cdvPath}`,
      (fileEntry) => {
        const nativePath = fileEntry.toURL()
        resolve(nativePath)
      },
      reject
    )
  })
}
